<!-- <div *ngIf="showOverlay" class="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
    <div class="bg-white p-6 rounded-lg shadow-lg text-center">
      <h2 class="text-2xl font-bold mb-4">Reminder</h2>
      <p class="mb-4">Please submit your morning task summary.</p>
      <button (click)="closeOverlay()" class="py-2 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-500">Close</button>
    </div>
  </div> -->

  <div *ngIf="showOverlay" class="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50">
    <div class="bg-white p-6 rounded-lg shadow-lg text-center">
      <h2 class="text-2xl font-bold mb-4">Reminder</h2>
      <p class="mb-4">Please submit your morning task summary.</p>
      <div class="flex justify-between">
        <button (click)="closeOverlay()" class="py-2 px-4 bg-red-600 text-white rounded-lg hover:bg-red-500">Dismiss</button>
        <button (click)="navigateToMorningMeeting()" class="py-2 px-4 bg-green-600 text-white rounded-lg hover:bg-green-500">Go to Morning Meeting</button>
      </div>
    </div>
  </div>